import React, { useState } from 'react';
import { Controller, FieldError, useFormContext } from 'react-hook-form';
import get from 'lodash/get';
import { Select } from '../../../../CommonComponents/OPL/Select/Select/Select';
import { DraftAccountDTO, ESigned as ESignedEnum, yesNoOpts } from '../../AccountOpening.meta';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { DisclosuresModal } from './components/Disclosures/Disclosures';
import { SpaceProps } from '../../../../theme/styledProps';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { EditableField } from '../../components/EditableField/EditableField';

const fieldName = 'eSigned';

interface Props extends SpaceProps {
  isReview?: boolean;
  draftAccount: DraftAccountDTO;
}

export const ESigned: React.FC<Props> = ({ isReview, draftAccount, ...rest }) => {
  const formBag = useFormContext();

  const {
    formState: { errors },
  } = formBag;

  const [isDisclosuresOpen, setIsDisclosuresOpen] = useState(false);

  const [isEditing, setIsEditing] = useState(!isReview);

  if (!isEditing) {
    return (
      <EditableField onEdit={() => setIsEditing(true)}>
        <Text fontWeight={500}>
          {get(draftAccount, fieldName) === ESignedEnum.Yes ? 'Yes' : 'No'}
        </Text>
      </EditableField>
    );
  }

  return (
    <Box {...rest}>
      <Controller
        control={formBag.control}
        name={fieldName}
        render={({ field }) => (
          <Select
            innerRef={field.ref}
            value={yesNoOpts.find(({ value }) => value === field.value)}
            label={
              isReview
                ? undefined
                : 'Do you acknowledge that you’re agreeing to our terms with an E-signature that is legal and equivalent of your manual signature?'
            }
            onChange={opt => {
              if (opt) {
                formBag.setValue(fieldName, opt.value, { shouldValidate: true });
              }
            }}
            options={yesNoOpts}
            formVariant={get(errors, fieldName) ? 'error' : undefined}
            helperText={(get(errors, fieldName) as FieldError | undefined)?.message}
            aria-label="Do you acknowledge that you’re agreeing to our terms with an E-signature that is legal and equivalent of your manual signature?"
          />
        )}
      />

      <Text fontSize="small" mt="4">
        By responding yes, you confirm that you accept the{' '}
        <Button variant="link" size="small" onClick={() => setIsDisclosuresOpen(true)}>
          Custodial Account Agreement
        </Button>
      </Text>

      {isDisclosuresOpen && <DisclosuresModal onClose={() => setIsDisclosuresOpen(false)} />}
    </Box>
  );
};
